import './ChatWindow.css';
import React, { useState, useEffect } from 'react';
import { api } from '../api/robyBackend';

export const MessageHeader = ({ app, sessionId, messageCount }) => {
  const [appName, setAppName] = useState('');
  const [contextRatio, setContextRatio] = useState(null); // 0..1+ (kann >1 sein bei Overflow)

  useEffect(() => {
    const fetchAppName = async () => {
      try {
        const response = await api.get(`/database/apps/${app}`);
        setAppName(response.data.name); // Speichere den App-Namen im Zustand
      } catch (error) {
        console.error('Error fetching app name:', error);
        setAppName('robyflow'); // Fallback in case of error
      }
    };

    if (app) {
      fetchAppName();
    }
  }, [app]);

  // Context-Window-Auslastung laden - wird mit jeder Nachricht (neuer messageCount) neu geholt,
  // damit die Anzeige immer den aktuellen Füllstand des Context Windows zeigt.
  useEffect(() => {
    let alive = true;
    const fetchContextStatus = async () => {
      try {
        const response = await api.get(`/chat/ai_foundry_agent/upload_status/${app}/${sessionId}`, { validateStatus: s => s < 500 });
        if (!alive) return;
        if (response.status < 400 && response.data) {
          setContextRatio(response.data.total_context_ratio ?? null);
        }
      } catch (error) {
        if (error.name === 'CanceledError' || error.name === 'AbortError') return;
        console.error('Error loading context status:', error);
      }
    };

    if (app && sessionId) {
      fetchContextStatus();
    } else {
      setContextRatio(null);
    }

    return () => { alive = false; };
  }, [app, sessionId, messageCount]);

  const percent = contextRatio !== null ? Math.round(contextRatio * 100) : null;
  const ringColor = percent === null ? '#026c70' : percent >= 90 ? '#dc3545' : percent >= 70 ? '#e6b800' : '#026c70';
  const clampedPercent = percent !== null ? Math.min(100, percent) : 0;

  return (
    <div className="header-container">
      <h2 className="app-message-title">{appName || 'Loading...'}</h2>
      {percent !== null && (
        <div
          className="context-usage-ring"
          style={{ '--ring-pct': clampedPercent, '--ring-color': ringColor }}
          title={`Context Window: ${percent}% belegt (Verlauf + Dokumente)`}
        >
          <span className="context-usage-ring__label">{percent}%</span>
        </div>
      )}
    </div>
  );
};
